import React, {useEffect, useState} from 'react'
import parse from 'html-react-parser'
import './EarQQuestionGroup.css'

function EarQQuestionGroup(props) {

    // console.log("EarQQuestionGroup props.questions[0].question", props.questions[0].question)
    const [answers, setAnswers] = useState([])
    const [groupHeader1, setGroupHeader1] = useState('')
    // const parse = require('html-react-parser')

    const [questions, setQuestions] = useState()
    // const [language, setLanguage] = useState(props.language || '')

    // console.log("Values", props.values)



    useEffect(() => {
        // console.log("FaceInstrumentQuestionGroup parsing:", props.questions[0].question_option)
        // console.log("EarQQuestionGroup props:", props)
        // question answers
        const q_answ = JSON.parse(`${props.questions[0].question[`question_option${props.language}`]}`) || []
        // question values
        const q_vals = JSON.parse(props.questions[0].question.question_option_values) || []
        // set answers as array - each element has properties: answer and value
        const q_answ_val = q_answ.length > 0 ? q_answ.map((a, i) => ({answer: a, value: q_vals[i]})) : []

        // console.log("**** EarQQuestionGroup **** q_answ_val", q_answ_val)


        const groupValues = props.questions.map(q => {return {...q, value:props.values[q.id]}})
        // console.log("group Values", groupValues)
        setQuestions(groupValues)
        setAnswers(q_answ_val)
        // setAnswers(JSON.parse(props.questions[0].question_option))

        // const parse = require('html-react-parser')
        // setGroupHeader1(parse(props.questions[0].group_header1))

    }, [props.group_id, props.errors, props.language, props.values])

    // const q_answers = JSON.parse(props.questions[0].question_option)

    const value_changed = (event) => {
        // console.log("Value changed",event.target)
        // console.log("Value changed name",event.target.name)
        // console.log("Value changed value",event.target.value)

        props.onChange(event.target.name, event.target.value)

    }

    return (
        <>
            {
                props.questions[0].question[`group_header1${props.language}`] && parse(`${props.questions[0].question[`group_header1${props.language}`]}`)
            }
            {
                props.questions[0].question[`group_header2${props.language}`] && parse(`${props.questions[0].question[`group_header2${props.language}`]}`)
            }
            {
                props.questions[0].question[`group_header3${props.language}`] && parse(`${props.questions[0].question[`group_header3${props.language}`]}`)
            }
            {answers.length > 0 ?
            
            <div className="border">
                
                <table className="table table-sm table-borderless">
                    <thead>
                        <tr>
                            {answers.map((opt,index) => 
                                <td scope="col" key={index}>{opt.answer}</td>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {questions.map((q, index, allQs) => 
                            <tr key={index}>
                                <td scope="row">
                                    <ul className='no-bullets-ul'>
                                        <li><span>{`${index+1}.`}&nbsp;</span>
                                            {props.errors.length > 0 && props.errors.includes(q.question.display_name_short) ? 
                                                <span className='text-danger'>{parse(`${q.question[`display_name${props.language}`]}`)}</span> 
                                                :
                                                // <span>{`${q.DictIntakeFormQuestion[`display_name${props.language}`]}`}</span>
                                                <span>{parse(`${q.question[`display_name${props.language}`]}`)}</span>
                                            }
                                            {/* {q.display_name} */}
                                        </li>
                                    </ul>
                                </td>
                                {answers.filter((opt,ix) => ix !== 0).map((opt,index) =>
                                    
                                    <td key={index}>
                                        <input className={`face-instruments-form-check-input ${props.errors.length > 0 && props.errors.includes(q.display_name_short) ? 'error' : 'good'}`}
                                            type={q.question.question_type} 
                                            // name={q.DictIntakeFormQuestion.display_name_short} 
                                            name={q.question.id} 
                                            id={`${q.question.display_name_short}_${index}`} 
                                            value={opt.value}
                                            onChange={value_changed}
                                            checked={q.value == opt.value}
                                            >
                                            
                                        </input>
                                    </td>
                                )}
                                
                            </tr>
                        )}
                    </tbody>
                </table>
                
            </div>
            :
            null
          }
        </>
    )
}

export default EarQQuestionGroup
